import { render, staticRenderFns } from "./DailyMotionPlayer.vue?vue&type=template&id=db7bbcb0&scoped=true"
import script from "./DailyMotionPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./DailyMotionPlayer.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DailyMotionPlayer.vue?vue&type=style&index=0&id=db7bbcb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7bbcb0",
  null
  
)

export default component.exports